import {
    BarElement,
    CategoryScale,
    ChartData,
    Chart as ChartJS,
    ChartOptions,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from 'chart.js';
import React from 'react';
import { Bar } from 'react-chartjs-2';

// Register the required Chart.js components.
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// Define the props for the component.
export interface ResponsiveChartProps {
    data: ChartData<'bar', number[], string>;
    options?: ChartOptions<'bar'>;
}

const ResponsiveChart: React.FC<ResponsiveChartProps> = ({ data, options }) => {
    const defaultOptions: ChartOptions<'bar'> = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: 'Stacked Bar Chart',
            },
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };

    // Merge custom options with the default options.
    const mergedOptions: ChartOptions<'bar'> = {
        ...defaultOptions,
        ...options,
        plugins: {
            ...defaultOptions.plugins,
            ...(options?.plugins || {}),
        },
        scales: {
            ...defaultOptions.scales,
            ...(options?.scales || {}),
        },
    };

    return (
        // Container div that ensures the chart takes the available space.
        <div style={{ position: 'relative', width: '100%', height: '100%', minHeight: '300px' }}>
            <Bar
                data={data}
                options={mergedOptions}
            />
        </div>
    );
};

export default ResponsiveChart;
